var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menus-admin"},[_c('menus',{attrs:{"filters":_vm.filters,"showLinkType":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }